import request from "@/utils/request";

/**
 * 获取当前用户签到状态
 */
export function getCheckinStatus() {
  return request.get("/api/checkin/status");
}

/**
 * 执行签到
 */
export function checkin() {
  return request.post("/api/checkin/checkin");
}

/**
 * 获取签到排行
 */
export function getCheckinRank() {
  return request.get("/api/checkin/rank");
}
